// extracted by mini-css-extract-plugin
module.exports = {"root":"LinkWithIcon_root__2kcYC","link":"LinkWithIcon_link__1osvy","icon":"LinkWithIcon_icon__2EOVm"};